module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-zh-TW.9349687d.jpg";